module.exports = __webpack_public_path__ + "img/errorsListRSD.9c5fd602.svg";